import { getRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";
import { CreateResourceLibraryDTO } from "utils/helpers/models/resource-library/resource-library.dto";

export const RESOURCE_LIBRARy_APIS = {
  uploadFile: (params: any) => postRequest("/file/upload", params),
  createResourceLibrary: (body: CreateResourceLibraryDTO) => postRequest(`/resource-library`, body),
  getResourceLibrary: (params: any) => getRequest(`/resource-library`, params),
  getResourceLibraryById: (id: number,) => getRequest(`/resource-library/${id}`),
  editResourceLibrary: (id: number, params: any) => putRequest(`/resource-library/${id}`, params),
};
